import { mirrorX } from "apparatus/draw";
//import { setDefaultStyle } from "apparatus/draw";
import { Group, Path } from "paper";
import { setDefaultStyleWithStroke } from "../draw";
import { DEFAULT_LIQUID_DATA, Segments } from "./common";
export class Cuvette {
    render(appearance) {
        // Standard cuvettes are 45 by 12.5mm. We round here for clarity.
        let width = 10;
        let height = 50;
        let graphic;
        let liquidMask;
        if (appearance.view == "side") {
            // This is simple, just draw  abox
            let depth = appearance.depth;
            let outline = new Path(Segments([[0, 0]], [[0, height]], [[depth, height]], [[depth, 0]]));
            liquidMask = outline.clone();
            graphic = outline;
        }
        else {
            let outside = new Path(Segments([[0, 0]], [[0, height]], [[width, height]], [[width, 0]]));
            graphic = new Group([outside]);
            let inside = (() => {
                switch (appearance.type) {
                    case "macro":
                        return new Path(Segments([[0, 0]], [[0, height]]));
                    case "semi-micro":
                        return new Path(Segments([[0, 0]], [[0, 20]], [[2.5, 23]], [[2.5, 46]]));
                    case "micro":
                        return new Path(Segments([[0, 0]], [[0, 20]], [[3.5, 24]], [[3.5, 46]]));
                }
            })();
            mirrorX(inside, width / 2);
            liquidMask = inside.clone();
            graphic.addChild(inside);
        }
        setDefaultStyleWithStroke("thinner", graphic);
        graphic.scale(appearance.scale);
        liquidMask.scale(appearance.scale, graphic.bounds.center);
        return {
            graphic: graphic,
            hitShape: graphic.bounds.expand(20).toShape(),
            liquidMask: liquidMask,
            snapping: graphic.placeable()
        };
    }
}
Cuvette.properties = {
    label: "Cuvette",
    canContainLiquids: true,
    defaultAppearance: {
        depth: 20,
        scale: 1.5,
        type: "semi-micro",
        view: "side"
    },
    defaultLiquidData: Object.assign(Object.assign({}, DEFAULT_LIQUID_DATA), { color: "#ff2020", amountRatio: 0.85 }),
    appearanceSpecs: [
        {
            spec: "slider", key: "scale", label: "Scale",
            min: 1.0, max: 5.0, step: 0.1,
        },
        {
            spec: "radio", key: "view", label: "View",
            options: [
                { value: "side", label: "From the side" },
                { value: "front", label: "Front view" },
            ],
        },
        {
            spec: "radio", key: "type", label: "Type",
            options: [
                { value: "macro", label: "Macro" },
                { value: "semi-micro", label: "Semi-Micro" },
                { value: "micro", label: "Micro", tier: "boost" },
            ],
            visible: a => a.view == "front"
        },
        {
            spec: "slider", key: "depth", label: "Depth",
            min: 5, max: 100,
            visible: a => a.view == "side"
        },
    ],
};
